export enum DocumentsBreadcrumbMutationTypes {
  ADD_ITEM = 'ADD_ITEM',
  SET_ITEMS = 'SET_ITEMS',
  REMOVE_ALL_AFTER = 'REMOVE_ALL_AFTER',
  RESET_BREADCRUMB = 'RESET_BREADCRUMB',
  UPDATE_FOLDER_NAVIGATION_TOKEN = 'UPDATE_FOLDER_NAVIGATION_TOKEN',
}
